import script from "./MainNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainNav.vue?vue&type=script&setup=true&lang=ts"

import "./MainNav.vue?vue&type=style&index=0&id=6d9a2478&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d9a2478"]])

export default __exports__